import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "..";

const getAllWhiskey = async () => {

    const whiskeys = []

    const today = Date.now()
    // const year = today.getFullYear()
    // const month = today.getMonth() + 1
    // const day = today.getDate()
    // const currentDate = year + "/" + month + "/" + day
    const q = query(collection(db, "whiskeyDetails"));


    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots

            whiskeys.push({ id: doc.id, ...doc.data() })
    });
    return whiskeys.sort((a,b) => a.date.seconds - b.date.seconds)
}

export default getAllWhiskey